<div class="app-page">
  @if (isLoading) {
    <div class="loading-indicator">
      <mat-progress-spinner
        class="example-margin"
        color="orange"
        mode="indeterminate"
        >
      </mat-progress-spinner>
    </div>
  }
  <mat-toolbar style="height: 60px;"  >


    <mat-form-field style="font-size: 14px;" >
      <mat-label>Roster - Season</mat-label>
      <mat-select [formControl]="seasonFormControl"  (selectionChange)="refreshData()">
        @for (season of _seasons; track season) {
          <mat-option  [value]="season">
            {{season.Name}}
          </mat-option>
        }

      </mat-select>
    </mat-form-field>
    &nbsp;
  </mat-toolbar>
  <div style="margin-left: 20px;;">
    <label >Display</label><br/>
    <mat-checkbox
      checked="true"
      (change)="this.PlayerRankingsIsVisible=!this.PlayerRankingsIsVisible;">
      Grades
    </mat-checkbox>
    &nbsp;
    <mat-checkbox
      checked="true"
      (change)="this.PlayerAssessmentsIsVisible=!this.PlayerAssessmentsIsVisible;">
      Player assessments
    </mat-checkbox>
    &nbsp;
    <mat-checkbox
      checked="false"
      (change)="this.DifferenceIsVisible=!this.DifferenceIsVisible;">
      Difference grade/player assessment
    </mat-checkbox>

  </div>
  <br/>
  <!--
  <mat-slide-toggle [checked]="this.PlayerRankingsIsVisible" color="primary" [(ngModel)]="PlayerRankingsIsVisible">PLAYER GRADES</mat-slide-toggle>
  <mat-slide-toggle [checked]="this.ScoutRankingsIsVisible" color="primary" [(ngModel)]="ScoutRankingsIsVisible" >GRADES</mat-slide-toggle> -->

  <div style="overflow-x:auto;margin-left: 9em; ">

    @if (this.perfData?.Players.length==0) {
      <div>
        NO PLAYERS ADDED FOR THIS SEASON
      </div>
    }
    @if (this.perfData?.Games.length==0) {
      <div style="color: gray; margin-top: 20px;">
        NO GAMES ADDED FOR THIS SEASON / NO GAMES PLAYED YET
      </div>
    }
    @if (this.perfData?.Players.length>0 && this.perfData?.Games.length>0) {
      <table style=" font-size: small;">
        <tr>
          <th>
          </th>
          @for (game of this.perfData.Games; track game) {
            @if (game.HomeTeamId == this.perfData.TeamId) {
              <th style="height: 100px; align-content: center;vertical-align: bottom;"><div class="verticalText" style="width:30px; overflow: visible;">{{game.AwayTeamName}}<br><label style="font-size: x-small; color: gray;">{{game.GameDate | date:'yyyy-MM-dd'}}</label></div></th>
            }
            @if (game.HomeTeamId != this.perfData.TeamId) {
              <th style="height: 100px; align-content: center;vertical-align: bottom;"><div class="verticalText" style="width: 30px; overflow: visible;">{{game.HomeTeamName}}<br><label style="font-size: x-small; color: gray;">{{game.GameDate | date:'yyyy-MM-dd'}}</label></div></th>
            }
          }
        </tr>
        <tr style="background-color: darkgray;">
          <th style="position: absolute ; left:0; top: auto; height: 20px;font-weight: bold;">GOAL TENDERS</th>
          <td style="padding: 0; height: 15px;" [attr.colspan]="this.perfData.Games.length"></td>
        </tr>
        @for (player of this.perfData.Players; track player) {
          @if (player.PositionId == 1) {
            <tr class="striped">
              <th style="position: absolute ; left:15px; top: auto; height: 20px;font-weight: normal;">
                <a [routerLink]="['/player/details', player.PlayerId]" style="color: white; font-weight: bold; text-decoration: none;">
                  {{player.JerseyNo}} {{player.LastName + "," + player.FirstName}}
                </a>
              </th>
              @for (game of player.Games; track game) {
                <td style="padding: 0; height: 20px;">
                  @if (game.Grades.length>0) {
                    <div   class="playerrating">
                      @for (rank of game.Grades; track rank) {
                        @if (rank.Ranking==1) {
                          <div class=" rankingbox-red " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">1</div>
                        }
                        @if (rank.Ranking==2) {
                          <div class=" rankingbox-yellow "  [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">2</div>
                        }
                        @if (rank.Ranking==3) {
                          <div class="rankingbox-lightgreen " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">3</div>
                        }
                        @if (rank.Ranking==4) {
                          <div class="rankingbox-green " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">4</div>
                        }
                        @if (rank.Ranking==5) {
                          <div class="rankingbox-blue " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">5</div>
                        }
                      }
                    </div>
                  }
                  @if (game.PlayerAssessment!=null) {
                    <div   class="playerassessment">
                      @if (game.PlayerAssessment.Ranking==1) {
                        <div class=" playerrankingbox-red " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">1</div>
                      }
                      @if (game.PlayerAssessment.Ranking==2) {
                        <div class=" playerrankingbox-yellow "  [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">2</div>
                      }
                      @if (game.PlayerAssessment.Ranking==3) {
                        <div class="playerrankingbox-lightgreen " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">3</div>
                      }
                      @if (game.PlayerAssessment.Ranking==4) {
                        <div class="playerrankingbox-green " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">4</div>
                      }
                      @if (game.PlayerAssessment.Ranking==5) {
                        <div class="playerrankingbox-blue " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">5</div>
                      }
                    </div>
                  }
                  @if (game.PlayerGradeVsAssessmentDifference<-0.5) {
                    <div class="diffbox-red" [style.display]="this.DifferenceIsVisible ? 'block':'none'" >
                      {{ game.PlayerGradeVsAssessmentDifference }}
                    </div>
                  }
                  @if (game.PlayerGradeVsAssessmentDifference > 0.5) {
                    <div class="diffbox-green"  [style.display]="this.DifferenceIsVisible ? 'block':'none'">
                      {{ game.PlayerGradeVsAssessmentDifference }}
                    </div>
                  }
                  @if (game.PlayerGradeVsAssessmentDifference>=-0.5 && game.PlayerGradeVsAssessmentDifference<=0.5 && game.PlayerGradeVsAssessmentDifference!=null ) {
                    <div  [style.display]="this.DifferenceIsVisible ? 'block':'none'" class="diffbox-gray" >
                      {{ game.PlayerGradeVsAssessmentDifference }}
                    </div>
                  }
                </td>
              }
            </tr>
          }
        }
        <tr style="background-color: darkgray;">
          <th style="position: absolute ; left:0; top: auto; height: 20px;font-weight: bold;">DEFENDERS</th>
          <td style="padding: 0; height: 15px;"  [attr.colspan]="this.perfData.Games.length"></td>
        </tr>
        @for (player of this.perfData.Players; track player) {
          @if (player.PositionId == 2 || player.PositionId == 3) {
            <tr class="striped">
              <th style="position: absolute ; left:15px; top: auto; height: 20px;font-weight: normal;">
                <a [routerLink]="['/player/details', player.PlayerId]" style="color: white; font-weight: bold; text-decoration: none;">
                  {{player.JerseyNo}} {{player.LastName + "," + player.FirstName}}
                </a>
              </th>
              @for (game of player.Games; track game) {
                <td style="padding: 0; height: 20px;">
                  @if (game.Grades.length>0) {
                    <div   class="playerrating">
                      @for (rank of game.Grades; track rank) {
                        @if (rank.Ranking==1) {
                          <div class=" rankingbox-red " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">1</div>
                        }
                        @if (rank.Ranking==2) {
                          <div class=" rankingbox-yellow "  [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">2</div>
                        }
                        @if (rank.Ranking==3) {
                          <div class="rankingbox-lightgreen " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">3</div>
                        }
                        @if (rank.Ranking==4) {
                          <div class="rankingbox-green " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">4</div>
                        }
                        @if (rank.Ranking==5) {
                          <div class="rankingbox-blue " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">5</div>
                        }
                      }
                    </div>
                  }
                  @if (game.PlayerAssessment!=null) {
                    <div   class="playerassessment">
                      @if (game.PlayerAssessment.Ranking==1) {
                        <div class=" playerrankingbox-red " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">1</div>
                      }
                      @if (game.PlayerAssessment.Ranking==2) {
                        <div class=" playerrankingbox-yellow "  [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">2</div>
                      }
                      @if (game.PlayerAssessment.Ranking==3) {
                        <div class="playerrankingbox-lightgreen " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">3</div>
                      }
                      @if (game.PlayerAssessment.Ranking==4) {
                        <div class="playerrankingbox-green " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">4</div>
                      }
                      @if (game.PlayerAssessment.Ranking==5) {
                        <div class="playerrankingbox-blue " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">5</div>
                      }
                    </div>
                  }
                  @if (game.PlayerGradeVsAssessmentDifference<-0.5) {
                    <div class="diffbox-red"  [style.display]="this.DifferenceIsVisible ? 'block':'none'">
                      {{ game.PlayerGradeVsAssessmentDifference }}
                    </div>
                  }
                  @if (game.PlayerGradeVsAssessmentDifference > 0.5) {
                    <div class="diffbox-green"  [style.display]="this.DifferenceIsVisible ? 'block':'none'">
                      {{ game.PlayerGradeVsAssessmentDifference }}
                    </div>
                  }
                  @if (game.PlayerGradeVsAssessmentDifference>=-0.5 && game.PlayerGradeVsAssessmentDifference<=0.5 && game.PlayerGradeVsAssessmentDifference!=null ) {
                    <div class="diffbox-gray"  [style.display]="this.DifferenceIsVisible ? 'block':'none'">
                      {{ game.PlayerGradeVsAssessmentDifference }}
                    </div>
                  }
                </td>
              }
            </tr>
          }
        }
        <tr style="background-color: darkgray;">
          <th style="position: absolute ; left:0; top: auto; height: 20px;font-weight: bold;">FORWARDS</th>
          <td style="padding: 0; height: 15px; "  [attr.colspan]="this.perfData.Games.length"></td>
        </tr>
        @for (player of this.perfData.Players; track player) {
          @if (player.PositionId > 3) {
            <tr class="striped">
              <th style="position: absolute ; left:15px; top: auto; height: 20px;font-weight: normal;">
                <a [routerLink]="['/player/details', player.PlayerId]" style="color: white; font-weight: bold; text-decoration: none;">
                  {{player.JerseyNo}} {{player.LastName + "," + player.FirstName}}
                </a>
              </th>
              @for (game of player.Games; track game) {
                <td style="padding: 0; height: 20px;">
                  @if (game.Grades.length>0) {
                    <div   class="playerrating">
                      @for (rank of game.Grades; track rank) {
                        @if (rank.Ranking==1) {
                          <div class=" rankingbox-red " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">1</div>
                        }
                        @if (rank.Ranking==2) {
                          <div class=" rankingbox-yellow "  [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">2</div>
                        }
                        @if (rank.Ranking==3) {
                          <div class="rankingbox-lightgreen " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">3</div>
                        }
                        @if (rank.Ranking==4) {
                          <div class="rankingbox-green " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">4</div>
                        }
                        @if (rank.Ranking==5) {
                          <div class="rankingbox-blue " [style.display]="this.PlayerRankingsIsVisible ? 'block':'none'">5</div>
                        }
                      }
                    </div>
                  }
                  @if (game.PlayerAssessment!=null) {
                    <div   class="playerassessment">
                      @if (game.PlayerAssessment.Ranking==1) {
                        <div class=" playerrankingbox-red " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">1</div>
                      }
                      @if (game.PlayerAssessment.Ranking==2) {
                        <div class=" playerrankingbox-yellow "  [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">2</div>
                      }
                      @if (game.PlayerAssessment.Ranking==3) {
                        <div class="playerrankingbox-lightgreen " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">3</div>
                      }
                      @if (game.PlayerAssessment.Ranking==4) {
                        <div class="playerrankingbox-green " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">4</div>
                      }
                      @if (game.PlayerAssessment.Ranking==5) {
                        <div class="playerrankingbox-blue " [style.display]="this.PlayerAssessmentsIsVisible ? 'block':'none'">5</div>
                      }
                    </div>
                  }
                  @if (game.PlayerGradeVsAssessmentDifference<-0.5) {
                    <div class="diffbox-red" [style.display]="this.DifferenceIsVisible ? 'block':'none'" >
                      {{ game.PlayerGradeVsAssessmentDifference }}
                    </div>
                  }
                  @if (game.PlayerGradeVsAssessmentDifference > 0.5) {
                    <div class="diffbox-green"  [style.display]="this.DifferenceIsVisible ? 'block':'none'">
                      {{ game.PlayerGradeVsAssessmentDifference }}
                    </div>
                  }
                  @if (game.PlayerGradeVsAssessmentDifference>=-0.5 && game.PlayerGradeVsAssessmentDifference<=0.5 && game.PlayerGradeVsAssessmentDifference!=null ) {
                    <div class="diffbox-gray"  [style.display]="this.DifferenceIsVisible ? 'block':'none'">
                      {{ game.PlayerGradeVsAssessmentDifference }}
                    </div>
                  }
                </td>
              }
            </tr>
          }
        }
      </table>
    }
  </div>

</div>